import { useGetFiltersManagement } from '@vindr/services/actions/filterManagement.action';
import { STATUS_ACTIVE } from '@vindr/services/constants/common.constant';
import { useDebounce } from '@vindr/utils/hooks/useDebounce';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';
import { Select } from 'antd';
import { FormItemProps } from '../templates/FormProps';
import FormSelect from '../templates/FormSelect';

interface Device extends FormItemProps {
  institution_id?: string;
  filterType: 0 | 1;
}

const FilterGroup = ({
  name = 'group',
  label = 'Group',
  placeholder = 'Select group',
  rules,
  required = true,
  onChange,
  disabled,
  multiple,
  institution_id,
  filterType,
  noStyle,
  ...props
}: Device) => {
  const [searchTerm, handleSearch] = useDebounce<string>();
  const { data, isInitialLoading, isRefetching } = useGetFiltersManagement(
    {
      limit: 100,
      offset: 0,
      institution_ids: [institution_id],
      status: STATUS_ACTIVE.ACTIVE,
      ...(searchTerm && { name: searchTerm }),
      // type: 1,
    },
    {
      enabled: !!institution_id,
    }
  );

  const devices = institution_id ? data?.data : [];

  const rulesMemo = useRoleMemo({ required, rules, disabled });

  return (
    <FormSelect
      {...{ name, label, placeholder, disabled }}
      {...(multiple && { mode: 'multiple' })}
      {...(onChange && { onChange })}
      {...(filterType === 0 && (rules || (required && { rules: rulesMemo })))}
      loading={isInitialLoading || isRefetching}
      noStyle={noStyle}
      onSearch={handleSearch}
      showSearch
      {...props}
    >
      {devices?.map((device) => (
        <Select.Option key={device.id} value={device.code}>
          {device.name}
        </Select.Option>
      ))}
    </FormSelect>
  );
};

export default FilterGroup;
